import styled from 'styled-components'

export const InfoHeaderWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
     p {
         font-size: 14px;
         margin-left: 11px; 
     }
`
export const InfoHeaderDivider = styled.div`
height: 24px;
width: 1px;
background-color: rgba(32, 32, 32, 0.1);
margin: 0 24px 0 24px;
`
